module.exports = __webpack_public_path__ + "static/media/absensi_harian.87a8cafe.png";